<template>
  <div>
    <div class="top">
      <Breadcrumb :options="breadcrumb" />
      <Wxts :wxtsList="wxtsList" />
    </div>

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      :allBtnWidth="allBtnWidth" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template slot="isdisplay" slot-scope="params">
        <MySwitch :data="params.params" :disabled="canNotHide.includes(params.params.id)" :activeValue="`1`"
          :inactiveValue="`2`" @onToggle="toggleDisplay"></MySwitch>
      </template>
    </Table>

    <FormDialog ref="dialog" :title="'字段设置'" :width="'550px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import Wxts from '../../../components/Wxts.vue';
export default {
  name: "FinanceDrivingFee",
  components: { Wxts },
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'dayauth',
      breadcrumb: [
        { name: "系统设置" },
        { name: "出车费用配置" },
      ],
      wxtsList: [
        {
          name: '资金类参与利润核算，非资金类不参与利润核算。'
        },
      ],
      formInline: {},
      formCtrl: [
        {
          label: "费用名称",
          keyName: "authname",
          placeholder: "请填写费用名称",
          type: "text",
        },
      ],
      cols: [
        { keyName: "authname", label: "费用名称" },
        // { keyName: "name", label: "费用类型" },
        { keyName: "dayauthsort", label: "排序" },
        { keyName: "isdisplay", label: "是否显示", slot: 'isdisplay' },
        { keyName: "nickname", label: "创建人" },
        { keyName: "addtime", label: "创建时间" },
      ],
      allBtnWidth: '100px',
      btns: [
        {
          ...this.editBtn,
          cb: (data) => {
            this.getItem(data)
            this.showDialog()
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
      viewMode: false,
      mform: { authname: undefined },
      mrules: {
        authname: [
          {
            required: true,
            message: '请填写费用名称',
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          label: "费用名称",
          keyName: "authname",
          err: "请填写费用名称",
          type: "text",
        },
        // {
        //   label: "费用类型",
        //   keyName: "isnum",
        //   type: "select",
        //   unit: "资金类项目将会进行资金合计",
        //   options: [
        //     { label: '全部', value: '' },
        //     { label: '资金类', value: 1 },
        //     { label: '非资金类', value: 2 },
        //   ],
        // },
        {
          label: "排序",
          keyName: "dayauthsort",
          err: "请填写排序",
          type: "number",
          unit: "数字越大排序越靠前",
        },
        {
          label: "是否显示",
          keyName: "isdisplay",
          type: "radio",
          options: [
            { label: '是', value: 1 },
            { label: '否', value: 2 },
          ],
        },
      ],
      canNotHide: [1, 2, 3, 4, 5],
      canNotEdit: [1, 2, 3, 4, 5],
    };
  },
  methods: {
    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = data.map(v => {
          const obj = this.dataObjHandler(v)
          obj.open = v.isdisplay + ''
          obj.DISABLED = this.canNotEdit.includes(obj.id)
          if (this.canNotEdit.includes(obj.id)) {
            obj.DISABLED = true
            obj.addtime = '-'
            obj.nickname = '-'
          }
          // console.log({...obj})
          return obj
        })
      }
      // console.log(this.tableData)
    },
    toggleDisplay({ id }) {
      let url = `${this.baseUrl}/upstatus`;
      const params = {
        // userid: this.user.id,
        id,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList(true)
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
          this.getList()
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    addItem() {
      delete this.mform.id
      this.mform = {
        authname: undefined,
        // isnum: 1,
        isdisplay: 1,
      }
      this.showDialog()
    },
    getItem({ id,
      authname,
      // isnum,
      isdisplay,
      dayauthsort,
    }) {
      this.mform = {
        ...this.mform,
        id,
        authname,
        // isnum,
        isdisplay,
        dayauthsort,
      }
    },
    onModalSubmit(data) {
      // console.log({ ...data })
      // console.log({ ...this.mform })
      this.loading = true
      let url = `${this.baseUrl}/addedu`;
      const params = {
        ...data,
        addid: this.user.id,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.hideDialog()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
}

/deep/ .dialog {
  .el-form {
    padding-right: 0 !important;

    .el-form-item .el-form-item__content .content {
      display: block;

      .unit {
        line-height: 30px;
        margin: 0 auto;
        font-size: 12px;
        color: #FF6756;
      }
    }

    .el-input {
      width: 230px;
    }
  }

  .btns .mians {
    text-align: center;
  }
}
</style>
